import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import { Container, FloatingLabel, Form } from "react-bootstrap";
import ContactInfo from "./ContactInfo";
import "./contact.css";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const Contact = () => {
  const formRef = useRef(null);
  const [result, showResult] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // Handle auto-dismissing success message safely without memory leaks
  useEffect(() => {
    let timer;
    if (result) {
      timer = setTimeout(() => {
        showResult(false);
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [result]);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          showResult(true);
          formRef.current.reset();
        },
        (error) => {
          console.error("FAILED...", error.text);
          setErrorMsg("Failed to send message. Please try again later.");
        },
      )
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section id="contact">
      <Container>
        <div className="contact-heading">
          <p className="section-kicker">
            <span /> Start a conversation
          </p>
          <h1>
            Let&apos;s make something
            <br />
            <em>worth using.</em>
          </h1>
          <p className="contact-lead">Have a project in mind, or simply want to say hello? My inbox is open.</p>
        </div>
        <div className="contact-layout">
          <div className="contact-details" data-aos="flip-right" data-aos-easing="linear" data-aos-duration="1500">
            <ContactInfo />
          </div>

          <div className="contact-form-wrap" data-aos="flip-left" data-aos-easing="linear" data-aos-duration="2000">
            <div className="form-heading">
              <span>Send a message</span>
              <small>I&apos;ll get back to you as soon as I can.</small>
            </div>
            <form ref={formRef} onSubmit={sendEmail} className="contact-form">
              <div className="form-group contact-field">
                <FloatingLabel controlId="floatingInputName" label="Name" className="mb-3">
                  <Form.Control type="text" name="from_name" placeholder="Name" required />
                </FloatingLabel>
              </div>

              <div className="form-group contact-field">
                <FloatingLabel controlId="floatingInputEmail" label="Your Email" className="mb-3">
                  <Form.Control type="email" name="reply_to" placeholder="Your email" required />
                </FloatingLabel>
              </div>

              <div className="form-group contact-field">
                <FloatingLabel controlId="floatingTextarea" label="Your Message" className="mb-3">
                  <Form.Control
                    as="textarea"
                    name="message"
                    required
                    placeholder="Your Message"
                    className="message-field"
                  />
                </FloatingLabel>
              </div>

              <div className="d-grid mt-4">
                <input
                  className="submit-btn"
                  type="submit"
                  value={loading ? "Sending..." : "Submit"}
                  disabled={loading}
                />
              </div>

              {result && (
                <div className="form-status form-success">
                  <p>Your message has been successfully sent. I&apos;ll contact you soon.</p>
                </div>
              )}

              {errorMsg && (
                <div className="form-status form-error">
                  <p>{errorMsg}</p>
                </div>
              )}
            </form>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Contact;
